// Arabic + English UI strings. Keep keys flat for simple lookup.
const TRANSLATIONS = {
  en: {
    // Site / brand
    "site.name": "SHAMSTRADE",
    "site.tagline": "Mastering Climate",

    // Header / nav
    "nav.shop": "Shop",
    "nav.split": "Split",
    "nav.cassette": "Cassette",
    "nav.floor": "Floor",
    "nav.duct": "Duct",
    "nav.calculator": "BTU Calculator",
    "nav.about": "About",
    "nav.cart": "Cart",
    "nav.wishlist": "Wishlist",
    "nav.compare": "Compare",
    "nav.admin": "Admin",
    "nav.account": "Account",
    "nav.signin": "Sign in",
    "nav.signout": "Sign out",

    // BTU calculator
    "calc.eyebrow": "Sizing tool",
    "calc.title": "Find the right size",
    "calc.subtitle": "Calibrated for Jordan",
    "calc.area": "Room area",
    "calc.people": "People in room",
    "calc.sunlight": "Sun exposure",
    "calc.sunny": "Sunny / west-facing",
    "calc.normal": "Normal",
    "calc.shaded": "Shaded",
    "calc.ceiling": "Ceiling height",
    "calc.kitchen": "Kitchen / heavy heat",
    "calc.topfloor": "Top floor / under roof",
    "calc.electronics": "TV / PC heat source",
    "calc.youNeed": "You need approximately",
    "calc.heatLoad": "Heat load",
    "calc.breakdown": "Show calculation breakdown",
    "calc.row.base": "Room base load",
    "calc.row.sunny": "Sunny room",
    "calc.row.shaded": "Shaded room",
    "calc.row.high_ceiling": "High ceiling",
    "calc.row.occupants": "Extra people",
    "calc.row.kitchen": "Kitchen heat",
    "calc.row.top_floor": "Top floor heat",
    "calc.row.electronics": "Electronics heat",
    "calc.disclaimer": "Estimates are guidance only. For oversized rooms or commercial spaces, call us — we'll do a free site survey.",

    "calc.page.eyebrow": "BTU sizing calculator",
    "calc.page.title": "Find the perfect A/C size for your space",
    "calc.page.intro": "Buying an A/C that's too small wastes money cooling slowly, and one too big wastes money cycling on and off. Our calculator is tuned to Jordan's climate and tells you exactly which BTU rating to look for in 30 seconds.",
    "calc.page.recommended": "Recommended for your space",
    "calc.page.viewAll": "View all matches",
    "calc.page.exactMatch": "EXACT MATCH",
    "calc.page.noMatch": "No products match this size right now — call us for a custom order.",
    "calc.page.tipsTitle": "Good to know",
    "calc.page.tip.t1": "1 ton ≈ 12,000 BTU. Most Jordanian living rooms need 1.5–2 ton (18,000–24,000 BTU).",
    "calc.page.tip.t2": "Inverter ACs adjust output dynamically, so being slightly oversized doesn't waste energy.",
    "calc.page.tip.t3": "South / west-facing rooms with large windows need ~20% more BTUs.",
    "calc.page.tip.t4": "Top floors and rooms directly under the roof gain heat fast — add 10%.",
    "calc.page.tip.t5": "Open kitchens need 4,000+ extra BTU to handle cooking heat.",
    "calc.page.expertEyebrow": "Need help?",
    "calc.page.expertTitle": "Talk to a sizing expert",
    "calc.page.expertText": "Got an unusual space — sloped ceilings, full-glass walls, server room? Call us for a free over-the-phone sizing consultation.",
    "calc.page.expertCta": "Call",

    // BTU combination suggestions
    "calc.combo.eyebrow": "Split across rooms",
    "calc.combo.title": "Other ways to reach this capacity",
    "calc.combo.intro": "Buying one big unit vs. splitting across several rooms changes the layout, power draw and price. Here are the most practical configurations:",
    "calc.combo.singleTag": "1 Unit",
    "calc.combo.unitsTag": "Units",
    "calc.combo.useCase.single": "One unit for the whole space",
    "calc.combo.useCase.equal": "Same-size units across rooms",
    "calc.combo.useCase.mixed": "Mixed sizes for different rooms",
    "calc.combo.useCase.apartment": "Apartment-friendly split",
    "calc.combo.total": "Total",
    "calc.combo.shop": "Shop",
    "nav.register": "Create account",

    // Common
    "common.from": "from",    "common.outOfStock": "Out of stock",
    "common.inStock": "In stock",
    "common.addToCart": "Add to cart",
    "common.selectSize": "Select size",
    "common.chooseSize": "Choose size",
    "common.orderOnWhatsApp": "Order on WhatsApp",
    "common.priceOnRequest": "Price on request",
    "common.requestQuote": "Request a quote",
    "common.quoteShort": "Quote",
    "common.chatOnWhatsApp": "Chat on WhatsApp",
    "common.callNow": "Call now",
    "common.units": "units",
    "common.cashOnDelivery": "Cash on installation (no card required)",
    "common.freeDelivery": "Free delivery — no minimum",
    "common.freeDesign": "Free space design included",
    "common.freeDesignSub": "Our engineers design your duct/cassette layout for free before installation.",
    "common.downloadSpec": "Download spec sheet (PDF)",
    "common.downloadManual": "Download user manual (PDF)",
    "common.qty": "Qty",
    "common.price": "Price",
    "common.total": "Total",
    "common.subtotal": "Subtotal",
    "common.discount": "Discount",
    "common.shipping": "Shipping",
    "common.continueShopping": "Continue shopping",
    "common.search": "Search",
    "common.loading": "Loading…",
    "common.save": "Save changes",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.close": "Close",
    "common.viewAll": "View all",
    "common.back": "Back",
    "common.remove": "Remove",
    "common.browseUnits": "Browse units",
    "common.free": "FREE",
    "common.calculatedAtCheckout": "Calculated at checkout",
    "common.addedToCart": "added to cart",
    "common.added": "Added to wishlist",
    "common.removedFromWishlist": "Removed from wishlist",
    "common.signInToSave": "Sign in to save",
    "common.compareLimit": "Compare limit is",
    "common.addedToCompare": "Added to compare",
    "common.removedFromCompare": "Removed from compare",
    "common.toast.couponApplied": "Coupon {code} applied",
    "common.toast.orderPlaced": "Order placed successfully!",
    "common.toast.reviewThanks": "Thanks for your review!",
    "common.toast.reorderEmpty": "None of these items are currently in stock",
    "common.toast.reorderAdded": "items added to cart",
    "common.toast.reorderFailed": "Reorder failed",

    // Cart
    "cart.title": "Your cart",
    "cart.empty": "Your cart is empty",
    "cart.checkout": "Proceed to checkout",
    "cart.itemCount": "items",
    "cart.itemCountSingular": "item",

    // Checkout
    "checkout.title": "Checkout",
    "checkout.cod": "Cash on installation",
    "checkout.shipping": "Shipping details",
    "checkout.savedAddresses": "Saved addresses",
    "checkout.fullName": "Full name",
    "checkout.phone": "Phone",
    "checkout.email": "Email",
    "checkout.forGuestReceipt": "we'll email your receipt here",
    "checkout.address": "Address",
    "checkout.city": "City",
    "checkout.notes": "Notes (optional)",
    "checkout.payment": "Payment",
    "checkout.codNote": "Cash on delivery — pay the technician on installation. No card required.",
    "checkout.payCOD": "Cash on delivery",
    "checkout.payCODSub": "Pay when the courier delivers your unit.",
    "checkout.payInstallation": "Cash on installation",
    "checkout.payInstallationSub": "Pay the technician after your AC is installed — no minimum, no card required.",
    "checkout.guestTip": "Checking out as a guest? You can create an account at any time to track orders.",
    "checkout.summary": "Order summary",
    "checkout.promoCode": "Promo code",
    "checkout.applyCoupon": "Apply",
    "checkout.placeOrder": "Place order",
    "checkout.placing": "Placing…",
    "checkout.signInToContinue": "Sign in to continue",

    // Auth
    "auth.welcome": "Welcome back",
    "auth.signIn": "Sign in",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.signInBtn": "Sign in",
    "auth.signingIn": "Signing in…",
    "auth.newHere": "New here?",
    "auth.createAccount": "Create an account",
    "auth.haveAccount": "Already have an account?",
    "auth.getStarted": "Get started",
    "auth.fullName": "Full name",
    "auth.phone": "Phone",
    "auth.passwordHint": "Password (min 6)",
    "auth.creating": "Creating…",
    "auth.createBtn": "Create account",
    "auth.forgotLink": "Forgot password?",
    "auth.forgotTitle": "Reset your password",
    "auth.forgotBody": "Enter your email and we'll send you a link to reset your password.",
    "auth.forgotBtn": "Send reset link",
    "auth.forgotSending": "Sending…",
    "auth.forgotSent": "If an account exists for that email, a reset link is on its way.",
    "auth.backToSignIn": "Back to sign in",
    "auth.resetTitle": "Choose a new password",
    "auth.newPassword": "New password",
    "auth.confirmPassword": "Confirm password",
    "auth.resetBtn": "Update password",
    "auth.resetting": "Updating…",
    "auth.resetSuccess": "Password updated. You can sign in now.",
    "auth.resetMismatch": "Passwords don't match.",
    "auth.resetInvalid": "This reset link is invalid or has expired.",

    // Account
    "account.title": "My account",
    "account.hello": "Hello",
    "account.savedAddresses": "Saved addresses",
    "account.orders": "Your orders",
    "account.noOrders": "You haven't placed any orders yet.",
    "account.orderId": "Order ID",
    "account.date": "Date",
    "account.items": "Items",
    "account.status": "Status",
    "account.track": "Track",
    "account.reorder": "Reorder",

    // Order status
    "status.pending": "Pending",
    "status.confirmed": "Confirmed",
    "status.shipped": "Shipped",
    "status.delivered": "Delivered",
    "status.cancelled": "Cancelled",

    // Tracking
    "tracking.placedOn": "Placed",
    "tracking.itemsTitle": "Items",
    "tracking.summary": "Summary",
    "tracking.shipping": "Shipping",
    "tracking.cancelled": "Order cancelled",
    "tracking.backToOrders": "← Back to my orders",
    "tracking.notFound": "Order not found",
    "tracking.backToAccount": "Back to account",
    "tracking.orderEyebrow": "Order",

    // Wishlist / Compare
    "wishlist.eyebrow": "Saved",
    "wishlist.title": "Your wishlist",
    "wishlist.empty": "Nothing saved yet.",
    "wishlist.emptyHint": "Tap the heart on any product to save it for later.",
    "wishlist.signInPrompt": "Sign in to view your wishlist",
    "compare.eyebrow": "Side by side",
    "compare.title": "Compare",
    "compare.empty": "Compare units side by side",
    "compare.emptyHint": "Tap the compare icon on any product card (up to 4) to stack them here.",
    "compare.clearAll": "Clear all",
    "compare.row.brand": "Brand",
    "compare.row.category": "Category",
    "compare.row.price": "Price",
    "compare.row.salePrice": "Sale Price",
    "compare.row.stock": "In Stock",
    "compare.row.btu": "BTU",
    "compare.row.type": "Type",
    "compare.row.energy": "Energy Rating",
    "compare.row.color": "Color",
    "compare.row.warranty": "Warranty",

    // Shop
    "shop.title": "Shop air conditioners",
    "shop.eyebrow": "Catalog · Live inventory",
    "shop.heroTitle1": "Cool every",
    "shop.heroTitle2": "corner.",
    "shop.searchPlaceholder": "Search BTU, brand, model…",
    "shop.filter": "Filter",
    "shop.all": "All",
    "shop.onSale": "On Sale",
    "shop.active": "Active:",
    "shop.clearAll": "Clear all",
    "shop.empty": "Nothing matches that.",
    "shop.emptyHint": "Try clearing some filters or use a different search.",
    "shop.resetFilters": "Reset filters",
    "shop.sort.featured": "Featured",
    "shop.sort.priceAsc": "Price: Low → High",
    "shop.sort.priceDesc": "Price: High → Low",
    "shop.sort.name": "Name A→Z",

    // Product detail
    "product.notFound": "Product not found",
    "product.backToShop": "Back to shop",
    "product.backToCatalog": "← Back to catalog",
    "product.chooseSize": "Choose size",
    "product.keyFeatures": "Key features",
    "product.review": "review",
    "product.reviews": "reviews",
    "product.specs.btu": "BTU",
    "product.specs.type": "Type",
    "product.specs.energy": "Energy",
    "product.specs.warranty": "Warranty",
    "product.aboutThisItem": "About this item",
    "product.inStockUnits": "In stock",
    "product.unitsOf": "units of",

    // Home
    "home.hero.eyebrow": "Climate engineering · Middle East",
    "home.hero.line1": "MASTERING",
    "home.hero.line2": "CLIMATE.",
    "home.hero.line3": "ROOM BY ROOM.",
    "home.hero.subheadline": "Premium air conditioners from Comfee, General, Viua and Milon. Pay on installation, certified warranties, same-day installation across Jordan.",
    "home.hero.ctaPrimary": "Shop the catalog",
    "home.hero.ctaSecondary": "Today's deals",
    "home.hero.flagship": "Flagship · Comfee Xpert AI Pro",
    "home.hero.aiproHeadline1": "MEET THE",
    "home.hero.aiproHeadline2": "AI PRO.",
    "home.hero.aiproHeadline3": "ROOM-SMART COOLING.",
    "home.hero.aiproBlurb": "AI-driven inverter split that senses the room, eliminates hot-spots and whispers while it cools. A flagship built for the harshest summers in Jordan.",
    "home.hero.viewAiPro": "View AI Pro",
    "home.hero.browseAll": "Browse all ACs",
    "home.hero.spec.btu": "BTU",
    "home.hero.spec.inverter": "AI Inverter",
    "home.hero.spec.energy": "Energy",
    "home.hero.spec.warranty": "Warranty",
    "home.hero.spec.years": "yrs",
    "home.hero.priceFrom": "from",
    "home.categories.eyebrow": "Browse",
    "home.categories.title": "Built for every space.",
    "home.categories.viewAll": "View all categories →",
    "home.categories.inStock": "in stock",
    "home.categories.label": "Category",
    "home.deals.eyebrow": "Limited time",
    "home.deals.title": "Deals of the day.",
    "home.featured.eyebrow": "Editor's pick",
    "home.featured.title": "Featured this season.",
    "home.featured.viewAll": "All products →",
    "home.lightCommercial.eyebrow": "For offices, shops & showrooms",
    "home.lightCommercial.title": "Light commercial range.",
    "home.lightCommercial.subtitle": "Cassette, floor-standing and concealed-duct ACs engineered for higher loads.",
    "home.newArrivals.eyebrow": "Fresh stock",
    "home.newArrivals.title": "New arrivals",
    "home.bestSellers.eyebrow": "Top sellers",
    "home.bestSellers.title": "Customers' favorites",
    "home.cta.text": "Need a unit installed today?",
    "home.cta.button": "Browse Units",
    "home.cta.call": "Call:",
    "home.stat.yearsOnMarket": "YEARS ON MARKET",
    "home.stat.unitsInstalled": "UNITS INSTALLED",
    "home.stat.customerRating": "CUSTOMER RATING",

    // Footer / Trust
    "footer.shop": "Shop",
    "footer.account": "Account",
    "footer.operating": "Operating",
    "footer.signin": "Sign in",
    "footer.createAccount": "Create account",
    "footer.myOrders": "My orders",
    "footer.wishlist": "Wishlist",
    "footer.about": "Mastering climate across the Middle East.",
    "footer.tagline": "Built with precision · Pay on installation",
    "footer.allRights": "All rights reserved",

    // About Us page
    "about.heroEyebrow": "Our story",
    "about.heroTitle": "Climate engineering, done right.",
    "about.heroSubtitle": "Shamstrade is Jordan's trusted authority on residential and commercial air conditioning — authorized distributor of leading global brands, engineered installations, and full lifecycle support.",
    "about.heroStatsLabel": "By the numbers",
    "about.storyEyebrow": "Who we are",
    "about.storyHeading": "Built on trust, run by engineers.",
    "about.storyBody": "Shamstrade is the authorized distributor for Comfee, General, Viua, Milon and other leading climate brands across Jordan.",
    "about.ctaShop": "Browse the catalog",
    "about.valuesEyebrow": "Why us",
    "about.valuesHeading": "Four promises. No fine print.",
    "about.locationEyebrow": "Visit",
    "about.locationHeading": "Come see us in person.",
    "about.locationSubtitle": "Drop by our showroom in Shams Al Shareqa — our team will walk you through every model.",
    "about.getDirections": "Get directions",
    "about.openInMaps": "Open in Google Maps",

    // Trust badges
    "trust.freeDelivery": "Free Delivery",
    "trust.freeDeliverySub": "No minimum order",
    "trust.warranty": "Real Warranty",
    "trust.warrantySub": "100% Trusted",
    "trust.cod": "Pay on installation",
    "trust.codSub": "No card required",
    "trust.support": "24/7 Support",
    "trust.supportSub": "Dedicated team",

    // Reviews
    "reviews.title": "What customers say",
    "reviews.eyebrow": "Reviews",
    "reviews.beFirst": "Be the first to leave a review.",
    "reviews.write": "Write a review",
    "reviews.signInPrompt": "Please {link} to write a review.",
    "reviews.signInLink": "sign in",
    "reviews.rating": "Rating",
    "reviews.titleField": "Title (optional)",
    "reviews.body": "Your review",
    "reviews.post": "Post review",
    "reviews.posting": "Posting…",

    // 3D
    "ac3d.dragHint": "Move to tilt · Live 3D",

    // Countdown
    "countdown.days": "Days",
    "countdown.hours": "Hours",
    "countdown.min": "Min",
    "countdown.sec": "Sec",

    // Order success
    "orderSuccess.title": "Order confirmed.",
    "orderSuccess.note": "Our team will call you within 24 hours to confirm delivery & installation. Pay the technician in cash on installation.",
    "orderSuccess.track": "Track this order",
    "orderSuccess.waButton": "Send order to WhatsApp",
    "orderSuccess.waHint": "Tap below to send your order details to our WhatsApp — we'll reply to confirm within minutes.",
    "orderSuccess.waMsgHeader": "New order from Shamstrade",
    "orderSuccess.waItems": "Items",
    "orderSuccess.waTotal": "Total",
    "orderSuccess.waShipTo": "Deliver to",
    "orderSuccess.waPayment": "Payment",
    "orderSuccess.waPaymentText": "Cash on installation",
  },

  ar: {
    // Site / brand
    "site.name": "شمس تريد",
    "site.tagline": "إتقان المناخ",

    // Header
    "nav.shop": "المتجر",
    "nav.split": "مكيف جداري",
    "nav.cassette": "كاسيت",
    "nav.floor": "مكيف عامودي",
    "nav.duct": "دكت مخفي بالسقف",
    "nav.calculator": "حاسبة BTU",
    "nav.about": "من نحن",

    // BTU calculator (Arabic)
    "calc.eyebrow": "أداة قياس",
    "calc.title": "اختر القدرة المناسبة",
    "calc.subtitle": "محسوبة لمناخ الأردن",
    "calc.area": "مساحة الغرفة",
    "calc.people": "عدد الأشخاص",
    "calc.sunlight": "تعرض الشمس",
    "calc.sunny": "مشمس / واجهة غربية",
    "calc.normal": "عادي",
    "calc.shaded": "مظلل",
    "calc.ceiling": "ارتفاع السقف",
    "calc.kitchen": "مطبخ / حرارة عالية",
    "calc.topfloor": "طابق علوي / تحت السقف",
    "calc.electronics": "تلفاز / كمبيوتر",
    "calc.youNeed": "تحتاج تقريباً",
    "calc.heatLoad": "الحمل الحراري",
    "calc.breakdown": "عرض تفاصيل الحساب",
    "calc.row.base": "الحمل الأساسي",
    "calc.row.sunny": "غرفة مشمسة",
    "calc.row.shaded": "غرفة مظللة",
    "calc.row.high_ceiling": "سقف مرتفع",
    "calc.row.occupants": "أشخاص إضافيون",
    "calc.row.kitchen": "حرارة المطبخ",
    "calc.row.top_floor": "حرارة الطابق العلوي",
    "calc.row.electronics": "حرارة الأجهزة الإلكترونية",
    "calc.disclaimer": "هذه التقديرات إرشادية فقط. للمساحات الكبيرة أو التجارية، تواصل معنا — فريقنا يقوم بمعاينة مجانية.",

    "calc.page.eyebrow": "حاسبة قدرة التبريد",
    "calc.page.title": "اختر القدرة المثالية لتبريد منزلك",
    "calc.page.intro": "شراء مكيف بقدرة أقل من اللازم يهدر الكهرباء في التبريد البطيء، وشراء مكيف بقدرة أكبر يهدر المال في التشغيل المتقطع. حاسبتنا معدلة لمناخ الأردن وتخبرك بالضبط أي قدرة BTU تحتاجها خلال 30 ثانية.",
    "calc.page.recommended": "موصى به لمساحتك",
    "calc.page.viewAll": "عرض جميع المطابقات",
    "calc.page.exactMatch": "تطابق تام",
    "calc.page.noMatch": "لا توجد منتجات تطابق هذه القدرة حالياً — اتصل بنا لطلب خاص.",
    "calc.page.tipsTitle": "جيد أن تعرف",
    "calc.page.tip.t1": "1 طن ≈ 12,000 BTU. معظم غرف المعيشة في الأردن تحتاج 1.5–2 طن.",
    "calc.page.tip.t2": "مكيفات الإنفرتر تعدل أداءها تلقائياً، فلا ضير من حجم أكبر قليلاً.",
    "calc.page.tip.t3": "الغرف الجنوبية / الغربية ذات النوافذ الكبيرة تحتاج 20% قدرة إضافية.",
    "calc.page.tip.t4": "الطوابق العلوية تكتسب الحرارة بسرعة — أضف 10%.",
    "calc.page.tip.t5": "المطابخ المفتوحة تحتاج 4,000+ BTU إضافية لتعويض حرارة الطهي.",
    "calc.page.expertEyebrow": "تحتاج مساعدة؟",
    "calc.page.expertTitle": "تحدث مع خبير قياس",
    "calc.page.expertText": "مساحة غير اعتيادية — أسقف مائلة، جدران زجاجية، غرفة خوادم؟ اتصل بنا للحصول على استشارة قياس مجانية عبر الهاتف.",
    "calc.page.expertCta": "اتصل",

    // BTU combination suggestions (Arabic)
    "calc.combo.eyebrow": "موزع على الغرف",
    "calc.combo.title": "خيارات أخرى للوصول لهذه القدرة",
    "calc.combo.intro": "شراء وحدة واحدة كبيرة أو توزيعها على عدة غرف يغير التركيب والاستهلاك والسعر. هذه أفضل التكوينات العملية:",
    "calc.combo.singleTag": "وحدة واحدة",
    "calc.combo.unitsTag": "وحدات",
    "calc.combo.useCase.single": "وحدة واحدة لكامل المساحة",
    "calc.combo.useCase.equal": "وحدات بنفس القدرة موزعة على الغرف",
    "calc.combo.useCase.mixed": "أحجام مختلفة لغرف مختلفة",
    "calc.combo.useCase.apartment": "حل مناسب للشقق",
    "calc.combo.total": "المجموع",
    "calc.combo.shop": "تسوق",
    "nav.cart": "السلة",
    "nav.wishlist": "المفضلة",
    "nav.compare": "مقارنة",
    "nav.admin": "الإدارة",
    "nav.account": "الحساب",
    "nav.signin": "تسجيل الدخول",
    "nav.signout": "تسجيل الخروج",
    "nav.register": "إنشاء حساب",

    // Common
    "common.from": "ابتداءً من",
    "common.outOfStock": "غير متوفر",
    "common.inStock": "متوفر",
    "common.addToCart": "أضف إلى السلة",
    "common.selectSize": "اختر الحجم",
    "common.chooseSize": "اختر الحجم",
    "common.orderOnWhatsApp": "اطلب عبر واتساب",
    "common.priceOnRequest": "السعر عند الطلب",
    "common.requestQuote": "اطلب عرض سعر",
    "common.quoteShort": "عرض السعر",
    "common.chatOnWhatsApp": "تواصل عبر واتساب",
    "common.callNow": "اتصل الآن",
    "common.units": "وحدات",
    "common.cashOnDelivery": "الدفع عند التركيب (بدون بطاقة ائتمان)",
    "common.freeDelivery": "توصيل مجاني — بدون حد أدنى",
    "common.freeDesign": "تصميم مجاني للمساحة",
    "common.freeDesignSub": "مهندسونا يصمّمون توزيع الدكت/الكاسيت في منزلك أو مكتبك مجاناً قبل التركيب.",
    "common.downloadSpec": "تحميل ورقة المواصفات (PDF)",
    "common.downloadManual": "تحميل دليل المستخدم (PDF)",
    "common.qty": "الكمية",
    "common.price": "السعر",
    "common.total": "الإجمالي",
    "common.subtotal": "المجموع الفرعي",
    "common.discount": "الخصم",
    "common.shipping": "الشحن",
    "common.continueShopping": "متابعة التسوق",
    "common.search": "بحث",
    "common.loading": "جارٍ التحميل…",
    "common.save": "حفظ التغييرات",
    "common.cancel": "إلغاء",
    "common.delete": "حذف",
    "common.edit": "تعديل",
    "common.close": "إغلاق",
    "common.viewAll": "عرض الكل",
    "common.back": "رجوع",
    "common.remove": "إزالة",
    "common.browseUnits": "تصفح الوحدات",
    "common.free": "مجاني",
    "common.calculatedAtCheckout": "يُحتسب عند الإتمام",
    "common.addedToCart": "تمت الإضافة إلى السلة",
    "common.added": "أُضيف إلى المفضلة",
    "common.removedFromWishlist": "أُزيل من المفضلة",
    "common.signInToSave": "سجّل الدخول للحفظ",
    "common.compareLimit": "حد المقارنة هو",
    "common.addedToCompare": "أُضيف إلى المقارنة",
    "common.removedFromCompare": "أُزيل من المقارنة",
    "common.toast.couponApplied": "تم تطبيق الكود {code}",
    "common.toast.orderPlaced": "تم تأكيد الطلب بنجاح!",
    "common.toast.reviewThanks": "شكراً على تقييمك!",
    "common.toast.reorderEmpty": "لا توجد منتجات متوفرة حالياً من هذا الطلب",
    "common.toast.reorderAdded": "منتجات أُضيفت إلى السلة",
    "common.toast.reorderFailed": "فشل إعادة الطلب",

    // Cart
    "cart.title": "سلتك",
    "cart.empty": "سلة التسوق فارغة",
    "cart.checkout": "إتمام الطلب",
    "cart.itemCount": "منتجات",
    "cart.itemCountSingular": "منتج",

    // Checkout
    "checkout.title": "إتمام الطلب",
    "checkout.cod": "الدفع عند التركيب",
    "checkout.shipping": "تفاصيل الشحن",
    "checkout.savedAddresses": "العناوين المحفوظة",
    "checkout.fullName": "الاسم الكامل",
    "checkout.phone": "رقم الهاتف",
    "checkout.email": "البريد الإلكتروني",
    "checkout.forGuestReceipt": "سنرسل لك إيصال الطلب على هذا البريد",
    "checkout.address": "العنوان",
    "checkout.city": "المدينة",
    "checkout.notes": "ملاحظات (اختياري)",
    "checkout.payment": "الدفع",
    "checkout.codNote": "الدفع عند الاستلام — ادفع للفني عند التركيب. لا حاجة لبطاقة ائتمان.",
    "checkout.payCOD": "الدفع عند الاستلام",
    "checkout.payCODSub": "ادفع لعامل التوصيل عند تسليم المكيف.",
    "checkout.payInstallation": "الدفع عند التركيب",
    "checkout.payInstallationSub": "ادفع للفنيّ بعد تركيب المكيف — بدون حد أدنى، بدون بطاقة.",
    "checkout.guestTip": "تتم عملية الشراء كضيف؟ يمكنك إنشاء حساب في أي وقت لتتبع الطلبات.",
    "checkout.summary": "ملخص الطلب",
    "checkout.promoCode": "كود الخصم",
    "checkout.applyCoupon": "تطبيق",
    "checkout.placeOrder": "تأكيد الطلب",
    "checkout.placing": "جارٍ التأكيد…",
    "checkout.signInToContinue": "سجّل الدخول للمتابعة",

    // Auth
    "auth.welcome": "أهلاً بعودتك",
    "auth.signIn": "تسجيل الدخول",
    "auth.email": "البريد الإلكتروني",
    "auth.password": "كلمة المرور",
    "auth.signInBtn": "تسجيل الدخول",
    "auth.signingIn": "جارٍ تسجيل الدخول…",
    "auth.newHere": "جديد هنا؟",
    "auth.createAccount": "أنشئ حساباً",
    "auth.haveAccount": "هل لديك حساب بالفعل؟",
    "auth.getStarted": "ابدأ الآن",
    "auth.fullName": "الاسم الكامل",
    "auth.phone": "رقم الهاتف",
    "auth.passwordHint": "كلمة المرور (٦ أحرف على الأقل)",
    "auth.creating": "جارٍ الإنشاء…",
    "auth.createBtn": "إنشاء حساب",
    "auth.forgotLink": "نسيت كلمة المرور؟",
    "auth.forgotTitle": "إعادة تعيين كلمة المرور",
    "auth.forgotBody": "أدخل بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور.",
    "auth.forgotBtn": "إرسال الرابط",
    "auth.forgotSending": "جارٍ الإرسال…",
    "auth.forgotSent": "إذا كان هذا البريد مسجلاً لدينا، سيصلك رابط إعادة التعيين قريباً.",
    "auth.backToSignIn": "العودة إلى تسجيل الدخول",
    "auth.resetTitle": "اختر كلمة مرور جديدة",
    "auth.newPassword": "كلمة المرور الجديدة",
    "auth.confirmPassword": "تأكيد كلمة المرور",
    "auth.resetBtn": "تحديث كلمة المرور",
    "auth.resetting": "جارٍ التحديث…",
    "auth.resetSuccess": "تم تحديث كلمة المرور. يمكنك تسجيل الدخول الآن.",
    "auth.resetMismatch": "كلمتا المرور غير متطابقتين.",
    "auth.resetInvalid": "رابط إعادة التعيين غير صالح أو منتهي الصلاحية.",

    // Account
    "account.title": "حسابي",
    "account.hello": "مرحباً",
    "account.savedAddresses": "العناوين المحفوظة",
    "account.orders": "طلباتك",
    "account.noOrders": "لم تقم بأي طلب حتى الآن.",
    "account.orderId": "رقم الطلب",
    "account.date": "التاريخ",
    "account.items": "المنتجات",
    "account.status": "الحالة",
    "account.track": "تتبع",
    "account.reorder": "إعادة الطلب",

    // Order status
    "status.pending": "قيد الانتظار",
    "status.confirmed": "مؤكد",
    "status.shipped": "تم الشحن",
    "status.delivered": "تم التسليم",
    "status.cancelled": "ملغى",

    // Tracking
    "tracking.placedOn": "تم الطلب",
    "tracking.itemsTitle": "المنتجات",
    "tracking.summary": "الملخص",
    "tracking.shipping": "الشحن",
    "tracking.cancelled": "تم إلغاء الطلب",
    "tracking.backToOrders": "← العودة إلى طلباتي",
    "tracking.notFound": "الطلب غير موجود",
    "tracking.backToAccount": "العودة إلى الحساب",
    "tracking.orderEyebrow": "طلب",

    // Wishlist / Compare
    "wishlist.eyebrow": "محفوظ",
    "wishlist.title": "قائمة المفضلة",
    "wishlist.empty": "لم تحفظ أي منتج بعد.",
    "wishlist.emptyHint": "اضغط على القلب في أي منتج لحفظه لاحقاً.",
    "wishlist.signInPrompt": "سجّل الدخول لعرض قائمة المفضلة",
    "compare.eyebrow": "جنباً إلى جنب",
    "compare.title": "مقارنة",
    "compare.empty": "قارن الوحدات جنباً إلى جنب",
    "compare.emptyHint": "اضغط على أيقونة المقارنة في أي بطاقة منتج (حتى ٤ منتجات) لإضافتها هنا.",
    "compare.clearAll": "مسح الكل",
    "compare.row.brand": "الماركة",
    "compare.row.category": "الفئة",
    "compare.row.price": "السعر",
    "compare.row.salePrice": "سعر العرض",
    "compare.row.stock": "متوفر",
    "compare.row.btu": "BTU",
    "compare.row.type": "النوع",
    "compare.row.energy": "كفاءة الطاقة",
    "compare.row.color": "اللون",
    "compare.row.warranty": "الكفالة",

    // Shop
    "shop.title": "تسوّق المكيفات",
    "shop.eyebrow": "الكتالوج · مخزون مباشر",
    "shop.heroTitle1": "برّد كل",
    "shop.heroTitle2": "زاوية.",
    "shop.searchPlaceholder": "ابحث بالطن، الماركة، الموديل…",
    "shop.filter": "تصفية",
    "shop.all": "الكل",
    "shop.onSale": "عروض",
    "shop.active": "النشط:",
    "shop.clearAll": "مسح الكل",
    "shop.empty": "لا توجد نتائج مطابقة.",
    "shop.emptyHint": "جرّب إزالة بعض الفلاتر أو استخدم بحثاً مختلفاً.",
    "shop.resetFilters": "إعادة ضبط الفلاتر",
    "shop.sort.featured": "مميّز",
    "shop.sort.priceAsc": "السعر: من الأقل للأعلى",
    "shop.sort.priceDesc": "السعر: من الأعلى للأقل",
    "shop.sort.name": "الاسم أ→ي",

    // Product detail
    "product.notFound": "المنتج غير موجود",
    "product.backToShop": "العودة إلى المتجر",
    "product.backToCatalog": "← العودة إلى الكتالوج",
    "product.chooseSize": "اختر الحجم",
    "product.keyFeatures": "المزايا الرئيسية",
    "product.review": "تقييم",
    "product.reviews": "تقييمات",
    "product.specs.btu": "قدرة التبريد (BTU)",
    "product.specs.type": "النوع",
    "product.specs.energy": "الطاقة",
    "product.specs.warranty": "الكفالة",
    "product.aboutThisItem": "عن هذا المنتج",
    "product.inStockUnits": "متوفر",
    "product.unitsOf": "وحدة من",

    // Home
    "home.hero.eyebrow": "هندسة المناخ · الشرق الأوسط",
    "home.hero.line1": "إتقان",
    "home.hero.line2": "المناخ.",
    "home.hero.line3": "غرفة بغرفة.",
    "home.hero.subheadline": "مكيفات هواء فاخرة من كومفي وجنرال وفيوا وميلون. الدفع عند التركيب، كفالات معتمدة، تركيب في نفس اليوم في جميع أنحاء الأردن.",
    "home.hero.ctaPrimary": "تسوّق الكتالوج",
    "home.hero.ctaSecondary": "عروض اليوم",
    "home.hero.flagship": "الطراز الرائد · كومفي إكسبرت AI برو",
    "home.hero.aiproHeadline1": "تعرّف على",
    "home.hero.aiproHeadline2": "AI برو.",
    "home.hero.aiproHeadline3": "تبريد ذكي لكل غرفة.",
    "home.hero.aiproBlurb": "مكيف إنفرتر مدعوم بالذكاء الاصطناعي يستشعر الغرفة ويوزّع البرودة بدون نقاط حارة، وبتشغيل هادئ جداً — طراز رائد مصمم لأقسى صيف في الأردن.",
    "home.hero.viewAiPro": "استعرض AI برو",
    "home.hero.browseAll": "تصفّح كل المكيفات",
    "home.hero.spec.btu": "BTU",
    "home.hero.spec.inverter": "إنفرتر ذكي",
    "home.hero.spec.energy": "كفاءة",
    "home.hero.spec.warranty": "كفالة",
    "home.hero.spec.years": "سنوات",
    "home.hero.priceFrom": "يبدأ من",
    "home.categories.eyebrow": "تصفّح",
    "home.categories.title": "مصممة لكل مساحة.",
    "home.categories.viewAll": "عرض كل الفئات ←",
    "home.categories.inStock": "متوفر",
    "home.categories.label": "الفئة",
    "home.deals.eyebrow": "وقت محدود",
    "home.deals.title": "عروض اليوم.",
    "home.featured.eyebrow": "اختيار المحرر",
    "home.featured.title": "مميّزات هذا الموسم.",
    "home.featured.viewAll": "كل المنتجات ←",
    "home.lightCommercial.eyebrow": "للمكاتب والمحلات والمعارض",
    "home.lightCommercial.title": "أنظمة التبريد التجارية.",
    "home.lightCommercial.subtitle": "مكيفات كاسيت وعامودي ودكت مخفي مصممة للأحمال العالية.",
    "home.newArrivals.eyebrow": "وصلنا حديثاً",
    "home.newArrivals.title": "أحدث المنتجات",
    "home.bestSellers.eyebrow": "الأكثر مبيعاً",
    "home.bestSellers.title": "اختيار الزبائن",
    "home.cta.text": "تحتاج وحدة وتركيباً اليوم؟",
    "home.cta.button": "تصفّح الوحدات",
    "home.cta.call": "اتصل:",
    "home.stat.yearsOnMarket": "سنوات في السوق",
    "home.stat.unitsInstalled": "وحدة مُركّبة",
    "home.stat.customerRating": "تقييم العملاء",

    // Footer / Trust
    "footer.shop": "تسوّق",
    "footer.account": "الحساب",
    "footer.operating": "نخدم",
    "footer.signin": "تسجيل الدخول",
    "footer.createAccount": "إنشاء حساب",
    "footer.myOrders": "طلباتي",
    "footer.wishlist": "قائمة المفضلة",
    "footer.about": "إتقان المناخ في جميع أنحاء الشرق الأوسط.",
    "footer.tagline": "صُنع بدقة · الدفع عند التركيب",
    "footer.allRights": "جميع الحقوق محفوظة",

    // About Us page
    "about.heroEyebrow": "قصتنا",
    "about.heroTitle": "هندسة التبريد، كما يجب أن تكون.",
    "about.heroSubtitle": "شمس تريد هي المرجع الموثوق لتكييف المنازل والمنشآت في الأردن — موزّع معتمد لأبرز العلامات العالمية، وتركيبات هندسية احترافية، ودعم متكامل طيلة عمر الجهاز.",
    "about.heroStatsLabel": "بالأرقام",
    "about.storyEyebrow": "من نحن",
    "about.storyHeading": "ثقة بُنيت، يديرها مهندسون.",
    "about.storyBody": "شمس تريد هي الموزع المعتمد لعلامات كومفي وجنرال وفيوا وميلون في الأردن.",
    "about.ctaShop": "تصفّح المنتجات",
    "about.valuesEyebrow": "لماذا نحن",
    "about.valuesHeading": "أربعة وعود. بلا شروط خفية.",
    "about.locationEyebrow": "زيارة",
    "about.locationHeading": "تفضّل بزيارتنا.",
    "about.locationSubtitle": "مرّ على معرضنا في شمس الشارقة — سيرافقك فريقنا في استعراض كل موديل.",
    "about.getDirections": "الوصول إلى الموقع",
    "about.openInMaps": "افتح في خرائط جوجل",

    // Trust badges
    "trust.freeDelivery": "توصيل مجاني",
    "trust.freeDeliverySub": "بدون حد أدنى",
    "trust.warranty": "كفالة معتمدة",
    "trust.warrantySub": "موثوقة 100%",
    "trust.cod": "الدفع عند التركيب",
    "trust.codSub": "بدون بطاقة ائتمان",
    "trust.support": "دعم 24/7",
    "trust.supportSub": "فريق متخصص",

    // Reviews
    "reviews.title": "ماذا يقول العملاء",
    "reviews.eyebrow": "التقييمات",
    "reviews.beFirst": "كن أول من يكتب تقييماً.",
    "reviews.write": "اكتب تقييماً",
    "reviews.signInPrompt": "يرجى {link} لكتابة تقييم.",
    "reviews.signInLink": "تسجيل الدخول",
    "reviews.rating": "التقييم",
    "reviews.titleField": "العنوان (اختياري)",
    "reviews.body": "تقييمك",
    "reviews.post": "نشر التقييم",
    "reviews.posting": "جارٍ النشر…",

    // 3D
    "ac3d.dragHint": "حرّك المؤشر للإمالة · 3D حي",

    // Countdown
    "countdown.days": "أيام",
    "countdown.hours": "ساعات",
    "countdown.min": "دقائق",
    "countdown.sec": "ثوانٍ",

    // Order success
    "orderSuccess.title": "تم تأكيد الطلب.",
    "orderSuccess.note": "سيتصل بك فريقنا خلال ٢٤ ساعة لتأكيد التسليم والتركيب. الدفع نقداً عند الاستلام.",
    "orderSuccess.track": "تتبع هذا الطلب",
    "orderSuccess.waButton": "إرسال الطلب عبر واتساب",
    "orderSuccess.waHint": "اضغط الزر أدناه لإرسال تفاصيل طلبك إلى واتساب — سنرد عليك للتأكيد خلال دقائق.",
    "orderSuccess.waMsgHeader": "طلب جديد من شمس الشارقة",
    "orderSuccess.waItems": "المنتجات",
    "orderSuccess.waTotal": "الإجمالي",
    "orderSuccess.waShipTo": "التوصيل إلى",
    "orderSuccess.waPayment": "الدفع",
    "orderSuccess.waPaymentText": "نقداً عند التركيب",
  },
};

// Brand-name dictionary (mapped to Arabic). Falls back to the original string.
const BRANDS = {
  ar: {
    // Only translate the store name itself. All product brand names
    // (Comfee, General, Viua, Milon, etc.) stay in Latin script even in AR mode
    // per owner preference (برند names sound odd transliterated).
    SHAMSTRADE: "شمس الشارقة",
    Shamstrade: "شمس الشارقة",
    "Shams AL Shareqa": "شمس الشارقة",
    "SHAMS AL SHAREQA": "شمس الشارقة",
    "shams al shareqa": "شمس الشارقة",
  },
};

// City dictionary
const CITIES = {
  ar: {
    Amman: "عمّان",
    Irbid: "إربد",
    Zarqa: "الزرقاء",
    Aqaba: "العقبة",
    Madaba: "مادبا",
    AMMAN: "عمّان",
    IRBID: "إربد",
    ZARQA: "الزرقاء",
  },
};

// AC type dictionary (split / cassette / floor / duct)
const TYPES = {
  ar: {
    split: "مكيف جداري",
    SPLIT: "مكيف جداري",
    cassette: "كاسيت",
    CASSETTE: "كاسيت",
    floor: "مكيف عامودي",
    FLOOR: "مكيف عامودي",
    duct: "دكت مخفي بالسقف",
    DUCT: "دكت مخفي بالسقف",
    inverter: "إنفرتر",
    INVERTER: "إنفرتر",
  },
};

export const translateBrand = (lang, value) => {
  if (!value) return "";
  if (lang !== "ar") return value;
  return BRANDS.ar[value] || value;
};

export const translateCity = (lang, value) => {
  if (!value) return "";
  if (lang !== "ar") return value;
  return CITIES.ar[value] || value;
};

export const translateType = (lang, value) => {
  if (!value) return "";
  if (lang !== "ar") return value;
  return TYPES.ar[value] || value;
};

export default TRANSLATIONS;
